import React from 'react';
import Layout from '../components/Layout';

const EidogenPage: React.FC = () => {
  return (
    <Layout currentPage="eidogen">
      <div className="p-4">
        <h1 className="text-2xl font-bold mb-4">Eidogen Management</h1>
        {/* Add Eidogen-specific content here */}
      </div>
    </Layout>
  );
};

export default EidogenPage;